export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtNDNahradaVolna';
export const NAME = 'SpravaIndivNahradNd';
